
import CloudCross from "../../../assets/outline/CloudCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudCrossIcon({ className, dataTestid = "CloudCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
